import { m, useReducedMotion } from "framer-motion";
import { duration, easing } from "./presets";

export default function HeroReveal({ children, className, delay = 0 }) {
    const reduceMotion = useReducedMotion();

    if (reduceMotion) {
        return <div className={className}>{children}</div>;
    }

    return (
        <m.div
            className={className}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: duration.fast, ease: easing, delay }}
        >
            {children}
        </m.div>
    );
}
